export default "__VITE_ASSET__DJ54eEK5__"